import type { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { FaSearch } from 'react-icons/fa';
import { InputAdornment, TextField } from '@mui/material';

interface FollowUpOwnerSearchProps {
  searchString: string;
  setSearchString: Dispatch<SetStateAction<string>>;
}

const FollowUpOwnerSearch: FC<FollowUpOwnerSearchProps> = ({
  searchString,
  setSearchString,
}) => {
  const { t } = useTranslation('followUp');
  return (
    <TextField
      aria-label="Follow-Up Owner Search"
      placeholder={t('toolBar.searchLabel')}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FaSearch />
          </InputAdornment>
        ),
        sx: (theme) => ({
          border: '2px solid',
          borderColor: theme.colors.neutral[100],
        }),
      }}
      value={searchString}
      onChange={(event) => setSearchString(event.target.value)}
    />
  );
};

export default FollowUpOwnerSearch;
